// @flow

import React from 'react';
import PropTypes from 'prop-types';

type OverlayPointProps = {
  text: PropTypes.string.isRequired,
};

const OverlayPoint = ({ text }: OverlayPointProps): React.Element<any> =>
  (<div className="center center--both">
    <div className="map__marker map__marker--callout center center--both h3 h3--tiny centered theme--blue-black">
      {text}
    </div>
  </div>);

export default OverlayPoint;



// WEBPACK FOOTER //
// ./screens/App/components/MapOverlayPoint/index.js